module.exports = __webpack_public_path__ + "img/island-condos-logo.199c5527.png";